import "yup-phone-lite"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Card, CardBody, CardFooter, Button, Input, Checkbox, link } from "@nextui-org/react"

import { usePost } from "../../api/reactQueryCustomHooks.jsx"
import { MainContainer } from "../../components/index.js"
import { apiRoute, linksUrl } from "../../constants/enum.js"
import { toast } from "react-toastify"

function CreateUserEntry() {
  const navigate = useNavigate()

  const [errors, setErrors] = useState({})
  const [isVisible, setIsVisible] = useState(false)
  const [isEditPassword, setIsEditPassword] = useState(false)
  const [isActive, setIsActive] = useState(true)
  const [isAdmin, setIsAdmin] = useState(false)
  const toggleVisibility = () => setIsVisible(!isVisible)
  const { isNewEntry, detailParams } = useSelector((state) => state.userMaster)
  const [formData, setFormData] = useState({
    userId: 0,
    firstName: "",
    lastName: "",
    loginName: "",
    emailId: "",
    contact_no: "",
    password: "",

  })



  const { isPending, mutate: funAddUpdate } = usePost({
    url: apiRoute.userMaster.addUpdate,
    queryKey: "UserMaster",
    onSuccessTasks: (data) => {
      console.log(data, "daay")
      navigate(linksUrl.user.userMaster)
    },
  })

  const { data: details = [], mutate: getDetail } = usePost({
    url: apiRoute.userMaster.getEntryData,
    queryKey: "fetuserDetail",
  });
  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }


  useEffect(() => {
    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
      const { UserId } = detailParams
      getDetail({
        data: {
          user_id: UserId
        }
      })
      // setIsEditPassword(false)
    }
  }, [detailParams])

  useEffect(() => {
    if (!isNewEntry && details && details?.length > 0) {
      setFormData({
        userId: details[0].UserId,
        firstName: details[0].FirstName,
        lastName: details[0].LastName,
        loginName: details[0].LoginName,
        contactNo: details[0].Contact_No,
        emailId: details[0].Email_Id,
        isActive: details[0].IsActive == 1 ? true : false,

      })
    }
  }, [details])

  console.log(details, isNewEntry, detailParams)

  const validateForm = () => {
    const newErrors = {}

    // Validate First Name
    if (formData.firstName.trim() === "") {
      newErrors.firstName = "First Name is required"
    }

    // Validate Last Name
    if (formData.lastName.trim() === "") {
      newErrors.lastName = "Last Name is required"
    }

    // Validate Login Name
    if (formData.loginName.trim() === "") {
      newErrors.loginName = "Login Name is required"
    }

    // Validate Email Id
    if (formData.emailId.trim() === "") {
      newErrors.emailId = "Email Id is required"
    }

    // Validate Contact No
    if (formData.contactNo.trim() === "") {
      newErrors.contactNo = "Contact No is required"
    }

    // Validate Password No
    if (formData.password.trim() === "") {
      newErrors.password = "Password No is required"
    }

    // Validate Confirm Password No
    if (formData.confirm_password.trim() === "") {
      newErrors.confirm_password = "Confirm Password No is required"
    }

    // Validate Confirm Password No
    if (formData.confirm_password.trim() !== formData.password.trim()) {
      newErrors.confirm_password = "Confirm Password should be same as Password"
    }

    setErrors(newErrors)

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    // if (validateForm()) {
    if (isEditPassword && formData.password.trim() == "" && formData.password == null) {
      toast.error("Enter Password", {
        position: "top-center"

      })
      return;

    }
    if ((isNewEntry || isEditPassword) && formData.confirm_password.trim() !== formData.password.trim()) {
      toast.error("Confirm Password should be same as Password", {
        position: "top-center"

      })
      return;
    }

    funAddUpdate({
      data: {
        userId: formData.userId,
        firstName: formData.firstName,
        lastName: formData.lastName,
        loginName: formData.loginName,
        emailId: formData.emailId,
        contactNo: formData.contactNo,
        password: isNewEntry ? formData.password : isEditPassword ? formData.password : '',
        roleId: 0,
        isActive: isActive ? 1 : 0,
        recStatus: isNewEntry ? 2 : 1
      },
    })
    //}
  }

  const onClickPrevPage = () => {
    navigate(linksUrl.user.userMaster)
  }

  return (
    <MainContainer
      breadcrumbs={["User Master", "New Entry"]}
      pageName={"Add User"}
      prevPage={{ show: true, onClick: onClickPrevPage }}

    >
      <Card className="w-full" shadow="none" classNames="p-0">
        <form onSubmit={handleSubmit}>
          <CardBody className="p-5">
            <div className="  ">
              <div className="flex w-full flex-wrap md:flex-nowrap sm:flex-nowrap mb-2  gap-4">
                <Input
                  type="text"
                  label="First Name"
                  placeholder=" "
                  variant="bordered"
                  labelPlacement="outside"
                  isRequired
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
                <Input
                  type="text"
                  label="Last Name"
                  placeholder=" "
                  variant="bordered"
                  labelPlacement="outside"
                  isRequired
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
                <Input
                  type="text"
                  label="Login Name"
                  placeholder=" "
                  labelPlacement="outside"
                  isRequired
                  variant="bordered"
                  name="loginName"
                  value={formData.loginName}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2  gap-4">
                <Input
                  type="text"
                  label="Email Id"
                  placeholder=" "
                  labelPlacement="outside"
                  isRequired
                  variant="bordered"
                  name="emailId"
                  value={formData.emailId}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
                <Input
                  type="text"
                  label="Contact No."
                  placeholder=" "
                  labelPlacement="outside"
                  variant="bordered"
                  name="contactNo"
                  value={formData.contactNo}
                  onChange={handleChange}
                  isDisabled={isPending}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 gap-4">
                <Input
                  label="Password"
                  placeholder=" "
                  labelPlacement="outside"
                  variant="bordered"
                  //isInvalid={errors?.password}
                  //errorMessage={errors?.password}
                  isRequired={isNewEntry ? true : false}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                />
                <Input
                  label="Confirm Password"
                  placeholder=" "
                  labelPlacement="outside"
                  variant="bordered"
                  isRequired={isNewEntry ? true : false}
                  //isInvalid={errors?.confirm_password}
                  //errorMessage={errors?.confirm_password}
                  name="confirm_password"
                  value={formData.confirm_password}
                  onChange={handleChange}
                  isDisabled={isPending}
                  endContent={
                    <button
                      className="focus:outline-none"
                      type="button"
                      onClick={toggleVisibility}
                    >
                      {isVisible ? (
                        <FontAwesomeIcon icon={faEyeSlash} />
                      ) : (
                        <FontAwesomeIcon icon={faEye} />
                      )}
                    </button>
                  }
                  type={isVisible ? "text" : "password"}
                />
              </div>
              <div className="flex w-full flex-wrap md:flex-nowrap mb-2 md:mb-0 gap-4">

                {!isNewEntry &&
                  <Checkbox size="md"
                    classNames={{ "label": "text-green-700 text-md font-semibold" }}
                    className="py-1 px-2 mt-2  " color={"success"} isSelected={isEditPassword}
                    onValueChange={setIsEditPassword} >Edit Password</Checkbox>
                }
                <Checkbox size="md"
                  classNames={{ "label": "text-green-700 text-md font-semibold" }}
                  className="py-1 px-2 mt-2  " color={"danger"} isSelected={isActive}
                  onValueChange={setIsActive} >Is Active</Checkbox>
              </div>
              <div className="w-full text-center my-5">
                <Button color="primary" type="submit" isLoading={isPending}>
                  Add User
                </Button>
              </div>
            </div>
          </CardBody>

        </form>
      </Card>
    </MainContainer>
  )
}

export default CreateUserEntry
